module.exports = {
    RECEIVE_ALL_HYDROGEOLOGICAL_ENTITIES: 'RECEIVE_ALL_HYDROGEOLOGICAL_ENTITIES',
    RECEIVE_HYDROGEOLOGICAL_ENTITY: 'RECEIVE_HYDROGEOLOGICAL_ENTITY',
}
